<template>
  <div>
    <!-- <div class="mt-5">
      <div class="row">
        <div class="col-lg-4 mb-3">
          <div class="grid-table grid-table_col-2">
            <div class="grid-table__item mb-2">Дата обращения:</div>
            <div class="grid-table__item mb-2">07.12.2025</div>
            <div class="grid-table__item mb-2">Сумма заявки:</div>
            <div class="grid-table__item mb-2">38 970 000</div>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <div class="grid-table grid-table_col-2">
            <div class="grid-table__item mb-2">На проверке:</div>
            <div class="grid-table__item mb-2">1 документ</div>
            <div class="grid-table__item mb-2">Осталось загрузить:</div>
            <div class="grid-table__item mb-2">6 документов</div>
            <div class="grid-table__item mb-2">Согласовано:</div>
            <div class="grid-table__item mb-2">1 документ</div>
          </div>
        </div>
        <div class="col-lg-4 mb-3">
          <div class="grid-table grid-table_col-2">
            <div class="grid-table__item mb-2">Список обновлен:</div>
            <div class="grid-table__item mb-2">28.12.2025 14:32</div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="leasing-summary">
      <div class="leasing-summary__head">
        <div class="leasing-summary__title">
          {{ leasing.KPPL_Name ? leasing.KPPL_Name : "&#8212;" }}
        </div>
        <div v-if="leasing.KPPL_SupplierName" class="leasing-summary__supplier">
          {{ leasing.KPPL_SupplierName }}
        </div>
      </div>

      <div class="leasing-summary__metrics">
        <div class="leasing-summary__metric">
          <div class="leasing-summary__label">Сумма расчета</div>
          <div class="leasing-summary__value">
            {{ leasing.Amount ? moneyMask(leasing.Amount) : "&#8212;" }}
          </div>
        </div>
        <div class="leasing-summary__metric">
          <div class="leasing-summary__label">Аванс</div>
          <div class="leasing-summary__value">
            {{
              leasing.Adv
                ? moneyMask((leasing.Price * leasing.Adv) / 100)
                : "&#8212;"
            }}
          </div>
        </div>
        <div class="leasing-summary__metric">
          <div class="leasing-summary__label">Срок лизинга</div>
          <div class="leasing-summary__value">
            {{ leasing.SL ? leasing.SL + " мес." : "&#8212;" }}
          </div>
        </div>
      </div>
    </div>

    <div>
      <h2 class="mt-4">Паспорт руководителя</h2>
      <div class="hr mt-2"></div>

      <div
        v-if="passportState?.alert"
        :class="'leasings-' + passportState.alert.tone"
        class="leasings-alert p-3 mt-4 mb-4"
        role="status"
      >
        {{ passportState.alert.text }}
        <div v-if="passportState.alert.refresh" class="mt-2">
          <ui-button class="btn btn-ghost btn-small" @click="refreshRecognition">
            Обновить статус
          </ui-button>
        </div>
      </div>

      <div v-if="filesPass.length === 0 && staged.length === 0" class="alert alert-info mt-3 mb-4">
        Прикрепите разворот с фото и страницу с регистрацией (JPG, PNG или PDF до 10 МБ)
        и нажмите «Отправить на проверку».
      </div>

      <input
        type="file"
        ref="file"
        style="display: none"
        accept=".jpg,.jpeg,.png,.pdf"
        @change="attachFiles"
        multiple
      />

      <ui-table v-if="filesPass.length > 0 || staged.length > 0" class="mt-3 mb-3">
        <table class="table">
          <tbody>
            <tr v-for="item in filesPass" :key="'sent-' + item.Id">
              <td>
                <div v-if="item.Status == 1" class="text-success text-nowrap">
                  Принято
                </div>
                <div
                  v-else-if="checking && !pollTimedOut"
                  class="d-flex align-items-center gap-2 text-secondary text-nowrap"
                >
                  <ui-loading-span />
                  Проверяется
                </div>
                <div v-else class="text-muted text-nowrap">Отправлен</div>
              </td>
              <td class="w-100 text-nowrap">
                {{ item.DocFileName || item.DocFile }}
              </td>
              <td class="text-end">
                <ui-button
                  @click="delPass(item.Id)"
                  :loading="item.loading"
                  :disabled="sending || checking"
                  class="btn btn-ghost btn-small"
                  >Удалить</ui-button
                >
              </td>
            </tr>
            <tr v-for="(item, index) in staged" :key="'new-' + index">
              <td>
                <div class="text-secondary text-nowrap">Не отправлен</div>
              </td>
              <td class="w-100 text-nowrap">{{ item.name }}</td>
              <td class="text-end">
                <ui-button
                  @click="unstage(index)"
                  :disabled="sending"
                  class="btn btn-ghost btn-small"
                  >Убрать</ui-button
                >
              </td>
            </tr>
          </tbody>
        </table>
      </ui-table>

      <div v-if="passportError" class="login-alert p-3 text-center mb-3">
        <div class="text-primary">Внимание!</div>
        <div>{{ passportError }}</div>
      </div>

      <div class="d-flex flex-wrap gap-2">
        <ui-button
          class="btn btn-ghost"
          @click="$refs.file.click()"
          :disabled="sending || totalFiles >= PASSPORT_MAX_FILES"
        >
          {{ totalFiles > 0 ? "Прикрепить ещё файл" : "Прикрепить файл" }}
        </ui-button>

        <ui-button
          v-if="canSend"
          class="btn btn-base"
          @click="sendPassport"
          :progress="btnUpload ? btnUpload : 0"
          :loading="sending"
          :disabled="sending || loading || loadingBack"
        >
          Отправить на проверку
        </ui-button>
      </div>
    </div>

    <div class="page-title">Документы для одобрения заявки на лизинг</div>
    <div class="hr mb-4"></div>

    <ui-table class="mt-4">
      <table class="table">
        <tbody>
          <tr v-if="docs?.anketa">
            <td>
              <!-- <div class="text-success text-nowrap">Принято</div> -->
              <!-- <div class="text-danger text-nowrap">Не принято</div> -->

              <div
                v-if="docs?.anketa?.Status == 1"
                class="text-success text-nowrap"
              >
                Принято
              </div>

              <div
                v-else-if="docs?.anketa?.Status == 0"
                class="text-danger text-nowrap"
              >
                Не принято
              </div>
            </td>

            <td class="w-100 text-nowrap">
              <div class="d-flex">
                <router-link
                  class="d-flex align-items-center line-height-1_2"
                  :to="route.params.id + '/application'"
                  >Анкета лизингополучателя ({{ docs?.anketa.LPName }}, ИНН
                  {{ docs?.anketa.LPINN }})</router-link
                >
              </div>
            </td>
            <td class="text-end">
              <!-- <ui-button class="btn btn-base btn-small">
                Подробнее
              </ui-button> -->
              <router-link
                :to="route.params.id + '/application'"
                class="btn btn-base btn-small"
              >
                Заполнить и подписать
              </router-link>
            </td>
          </tr>
          <tr v-if="docs?.dirSopd">
            <td>
              <div
                v-if="docs?.dirSopd?.Status >= 1"
                class="text-success text-nowrap"
              >
                Принято
              </div>
              <div
                v-else-if="docs?.dirSopd?.Status >= 0"
                class="text-danger text-nowrap"
              >
                Не принято
              </div>
            </td>
            <td class="w-100 text-nowrap">
              <div class="d-flex">
                <router-link
                  class="d-flex align-items-center line-height-1_2"
                  :to="route.params.id + '/personal-data-consent'"
                  >Согласие на обработку персональных данных ({{
                    formatFIO(docs?.dirSopd)
                  }}, ИНН {{ docs?.dirSopd.inn }})</router-link
                >
              </div>
            </td>
            <td class="text-end">
              <router-link
                :to="route.params.id + '/personal-data-consent'"
                class="btn btn-base btn-small"
              >
                Заполнить и подписать
              </router-link>
            </td>
          </tr>

          <!-- <tr>
            <td>
              <div class="text-danger text-nowrap">Не принято</div>
            </td>
            <td class="w-100 text-nowrap">
              <div class="d-flex">
                <router-link :to="'/sign'" target="_blank"
                  >Согласие на обработку персональных данных (Сенчихин М. В.,
                  ИНН 503225878040)
                </router-link>
              </div>
            </td>
            <td class="text-end">
              <router-link
                :to="route.params.id + '/personal-data-consent'"
                class="btn btn-ghost btn-small"
              >
                Отправить ссылку
              </router-link>
            </td>
          </tr> -->

          <template v-if="docs?.sopd && docs?.sopd.length > 0">
            <tr v-for="(item, index) in docs.sopd" :key="index">
              <td>
                <div v-if="item?.Status >= 1" class="text-success text-nowrap">
                  Принято
                </div>
                <div
                  v-else-if="item?.Status >= 0"
                  class="text-danger text-nowrap"
                >
                  Не принято
                </div>
              </td>
              <td class="text-nowrap">
                <div class="d-flex">
                  <a
                    :href="'https://lc.stone-xxi.ru/sign/?UID=' + item.RID"
                    target="_blank"
                    class="text-decoration-none"
                    >Согласие на обработку персональных данных ({{
                      formatFIO(item)
                    }}, ИНН {{ item.inn }})
                  </a>
                </div>
              </td>
              <td class="text-end">
                <div v-if="item?.Status >= 1" class="text-success">
                  <div
                    class="d-flex flex-wrap gap-1 flex-nowrap justify-content-end"
                  >
                    <ui-button
                      :to="'https://lc.stone-xxi.ru/sign/?UID=' + item.RID"
                      class="btn btn-base btn-small"
                    >
                      Подробнее
                    </ui-button>
                  </div>
                </div>
                <div v-else-if="item?.Status >= 0" class="text-danger">
                  <div
                    class="d-flex flex-wrap gap-1 flex-nowrap justify-content-end"
                  >
                    <ui-button
                      @click="() => modalClose(item)"
                      class="btn btn-ghost btn-small"
                    >
                      Отправить ссылку
                    </ui-button>

                    <a
                      :href="'https://lc.stone-xxi.ru/sign/?UID=' + item.RID"
                      target="_blank"
                      class="btn btn-base btn-small"
                    >
                      Заполнить и подписать
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </ui-table>

    <div v-if="error" class="login-alert p-3 text-center mt-4">
      <div class="text-primary">Внимание!</div>
      <div>{{ error }}</div>
    </div>

    <div class="row mt-4">
      <div class="col-auto">
        <div class="d-flex flex-wrap gap-2">
          <ui-button
            class="btn btn-ghost"
            @click="back"
            :loading="loadingBack"
            :disabled="sending || loadingBack || loading"
          >
            Вернуться к расчету
          </ui-button>

          <ui-button
            class="btn btn-base"
            @click="next"
            :loading="loading"
            :disabled="sending || loadingBack || loading"
          >
            Отправить на одобрение
          </ui-button>
        </div>
      </div>
    </div>

    <ui-modal v-if="modal" :close="modalClose">
      <div class="modal-header">
        <h5 class="modal-title">Отправить ссылку</h5>
        <button class="btn-close" type="button" @click="modalClose"></button>
      </div>
      <div class="modal-body">
        <p>Введите e-mail учредителя для отправки ссылки.</p>

        <!-- <ui-input-box :error="errorsLink.message">
        <ui-textarea v-model="message" placeholder="Сообщение" rows="3" />
      </ui-input-box> -->

        <ui-input-box-floating :error="errorsLink?.FounderFLINN">
          <ui-input type="text" v-model="email" placeholder="E-mail" />
          <ui-input-label>E-mail</ui-input-label>
        </ui-input-box-floating>

        <div v-if="errorLink" class="login-alert p-3 text-center mt-3">
          <div class="text-primary">{{ errorLink.error }}</div>
          <span>{{ errorLink.msg }}</span>
        </div>

        <div v-if="successLink" class="success-alert p-3 text-center mt-3">
          <div class="text-primary">Внимание!</div>
          <span>{{ successLink }}</span>
        </div>

        <ui-button
          @click="sendLink"
          class="btn-base mt-3 me-2"
          :loading="loadingSendLink"
          >Отправить</ui-button
        >
      </div>
      <!-- <div class="modal-footer"></div> -->
    </ui-modal>
  </div>
</template>



<script setup>
import { computed, onBeforeUnmount, ref, watch } from "vue";

import { postApi, downloadApi, moneyMask, dateMask, uploadApi } from "@/run";

import { onBeforeRouteLeave, useRoute } from "vue-router";
import "../style.css";

// Получаем текущий маршрут
const route = useRoute();

const props = defineProps({
  setStatus: {
    type: Function,
  },
  setPro: {
    type: Function,
  },
  docs: {
    filesPass: {
      type: Array,
      default: () => {},
    },
  },
  leasing: {
    filesPass: {
      type: Array,
      default: () => {},
    },
  },
  filesPass: {
    type: Array,
    default: () => [],
  },
  // Паспорт руководителя из ответа /leasing: { recognition, unavailable }. undefined — не пришёл.
  passport: {
    type: Object,
    default: undefined,
  },
});

const formatFIO = (item) => {
  const ln = item.LastName || "";
  const fn = item.FirstName ? item.FirstName[0] + "." : "";
  const mn = item.MidName ? item.MidName[0] + "." : "";
  return `${ln} ${fn} ${mn}`;
};

const loading = ref(false);
const error = ref(false);

const next = () => {
  error.value = false;
  if (staged.value.length > 0) {
    passportError.value =
      "Прикреплённые файлы паспорта не отправлены: нажмите «Отправить на проверку» или уберите их.";
    return;
  }

  loading.value = true;

  postApi("/leasing/setStatus", {
    id: route.params.id,
    status: 2,
  }).then((response) => {
    if (response.error) {
      error.value = response.error;
    }

    response.pro && props.setPro({ pro: response.pro, StatusKP: 0 });

    response.Status && props.setStatus(response.Status);

    loading.value = false;
  });
};

const loadingBack = ref(false);

const back = () => {
  loadingBack.value = true;

  postApi("/leasing/setStatus", {
    id: route.params.id,
    status: 0,
  }).then((response) => {
    (response.Status || response.Status == 0) &&
      props.setStatus(response.Status);

    loadingBack.value = false;
  });
};

const file = ref(null);
const docs = ref([]);
const filesPass = ref([]);

const btnUpload = ref(null);
const progressUpload = (btnRef, progress) => {
  btnRef.value = progress;
};

// Паспорт руководителя: файлы прикрепляются в браузере (staged), в ЛК не сохраняются и одной отправкой
// уходят в сервис распознавания вместе с уже отправленными файлами компании. Итог приходит в /leasing;
// пока проверка идёт — опрос /leasing/passportStatus раз в 3 с, не дольше 2 минут.
const PASSPORT_EXTENSIONS = ["jpg", "jpeg", "png", "pdf"];
const PASSPORT_MAX_BYTES = 10 * 1024 * 1024;
const PASSPORT_MAX_FILES = 5;
const POLL_MS = 3000;
const POLL_LIMIT = 40;

const staged = ref([]);
const sending = ref(false);
const passportError = ref(null);
const recognition = ref(null);
const unavailable = ref(false);
const outdated = ref(false);
const pollTimedOut = ref(false);
let pollTimer = null;
let pollCount = 0;

const totalFiles = computed(() => filesPass.value.length + staged.value.length);
const checking = computed(() => !!recognition.value && !recognition.value.final);

const canSend = computed(
  () =>
    staged.value.length > 0 ||
    (outdated.value && filesPass.value.length > 0 && !checking.value)
);

const WAITING = ["ready", "action_required", "incomplete", "received"];

// Итог проверки паспорта — плашкой под заголовком (цвета как на этапе одобрения). Пока идёт проверка,
// плашки нет: спиннер «Проверяется» стоит у файлов.
const passportState = computed(() => {
  // Неотправленные файлы видны в таблице («Не отправлен»).
  if (staged.value.length > 0) return null;
  if (outdated.value && filesPass.value.length > 0) {
    return {
      alert: { tone: "warning", text: "Файлы паспорта изменились — отправьте их на проверку ещё раз." },
    };
  }
  const r = recognition.value;
  if (!r) {
    return unavailable.value && filesPass.value.length > 0
      ? { alert: { tone: "primary", text: "Статус проверки паспорта сейчас недоступен. Обновите страницу позже." } }
      : null;
  }
  if (!r.final) {
    return pollTimedOut.value
      ? {
          alert: {
            tone: "primary",
            text: "Проверка занимает больше времени, чем обычно. Результат появится здесь — обновите статус через несколько минут.",
            refresh: true,
          },
        }
      : null;
  }
  if (r.status === "verified") {
    return {
      alert: {
        tone: "success",
        text: r.person ? `Паспорт проверен: ${r.person}, паспорт ${r.passport}.` : r.message,
      },
    };
  }
  return { alert: { tone: WAITING.includes(r.status) ? "primary" : "danger", text: r.message } };
});

const stopPolling = () => {
  clearTimeout(pollTimer);
  pollTimer = null;
};

const setRecognition = (value, restartPolling = false) => {
  recognition.value = value || null;
  outdated.value = !!value?.outdated;
  if (restartPolling) {
    pollCount = 0;
    pollTimedOut.value = false;
  }
  stopPolling();
  if (recognition.value && !recognition.value.final) {
    if (pollCount++ < POLL_LIMIT) {
      pollTimer = setTimeout(() => loadRecognition(recognition.value.id), POLL_MS);
    } else {
      pollTimedOut.value = true;
    }
  }
};

const loadRecognition = (recognitionId = null) => {
  postApi("/leasing/passportStatus", {
    id: route.params.id,
    recognitionId: recognitionId,
  }).then((response) => {
    if (!response || response.error) return;
    if (Array.isArray(response.files)) filesPass.value = response.files;
    unavailable.value = !!response.unavailable;
    if (response.recognition !== undefined) setRecognition(response.recognition);
  });
};

onBeforeUnmount(stopPolling);

// Проверка затянулась и опрос остановлен — пользователь запускает его заново кнопкой.
const refreshRecognition = () => {
  if (!recognition.value) return;
  pollCount = 0;
  pollTimedOut.value = false;
  loadRecognition(recognition.value.id);
};

const fileKey = (item) => `${item.name}|${item.size}|${item.lastModified}`;

const attachFiles = (e) => {
  passportError.value = null;
  const selected = Array.from(e.target.files);
  file.value.value = null;

  for (const item of selected) {
    const extension = (item.name.split(".").pop() || "").toLowerCase();
    if (!PASSPORT_EXTENSIONS.includes(extension)) {
      passportError.value = `Файл «${item.name}»: допустимы форматы JPG, JPEG, PNG и PDF.`;
      return;
    }
    if (item.size > PASSPORT_MAX_BYTES) {
      passportError.value = `Файл «${item.name}» больше 10 МБ.`;
      return;
    }
  }

  const known = new Set(staged.value.map(fileKey));
  const fresh = selected.filter((item) => !known.has(fileKey(item)));
  if (totalFiles.value + fresh.length > PASSPORT_MAX_FILES) {
    passportError.value = `Можно прикрепить не больше ${PASSPORT_MAX_FILES} файлов паспорта.`;
    return;
  }
  staged.value = [...staged.value, ...fresh];
};

const unstage = (index) => {
  passportError.value = null;
  staged.value = staged.value.filter((_, i) => i !== index);
};

const sendPassport = () => {
  passportError.value = null;
  sending.value = true;

  const request =
    staged.value.length > 0
      ? uploadApi(
          "/leasing/addFile",
          { files: staged.value, data: { type: 23, id: route.params.id } },
          btnUpload,
          progressUpload
        )
      : postApi("/leasing/passportRecheck", { id: route.params.id });

  request
    .then((response) => {
      if (!response) {
        passportError.value =
          "Паспорт не отправлен. Попробуйте ещё раз позже.";
        return;
      }
      if (response.error) {
        passportError.value = response.msg || response.error;
        return;
      }
      staged.value = [];
      if (Array.isArray(response.files)) filesPass.value = response.files;
      unavailable.value = false;
      setRecognition(response.recognition, true);
    })
    .finally(() => {
      btnUpload.value = null;
      sending.value = false;
    });
};

const delPass = (id) => {
  const item = filesPass.value.find((f) => f.Id === id);
  if (!item) return;

  item.loading = true;
  passportError.value = null;

  postApi("/leasing/delFile", {
    id: id,
  })
    .then((response) => {
      if (response.status) {
        filesPass.value = filesPass.value.filter((f) => f.Id !== id);
        // Итог проверки относился к прежнему набору файлов.
        if (recognition.value) outdated.value = true;
      }
    })
    .finally(() => {
      item.loading = false;
    });
};

// Неотправленные файлы живут только в браузере — переспрашиваем при переходе на другую страницу ЛК.
onBeforeRouteLeave(() =>
  staged.value.length === 0 ||
  window.confirm("Прикреплённые файлы паспорта не отправлены. Уйти со страницы?")
);

const progressDownload = (id, progress) => {
  console.log(id, progress);
};

// const downloadPass = (id) => {
//   const item = filesPass.value.find((f) => f.Id === id);
//   if (!item) return;

//   // Ставим флаг загрузки
//   item.loadingDownload = true;

//   downloadApi(
//     "/leasing/downloadFile",
//     {
//       id: id,
//     },
//     id,
//     progressDownload
//   )
//     .then((response) => {
//       const jsonData =
//         typeof response === "string" ? JSON.parse(response) : response;

//       if (jsonData.error) {
//         console.log({
//           title: "Ошибка",
//           msg: jsonData.error,
//         });
//       }
//     })
//     .finally(() => {
//       item.loadingDownload = false;
//     });
// };

const modal = ref(false);
const email = ref(null);
const loadingSendLink = ref(false);
const errorLink = ref(null);
const errorsLink = ref(null);
const successLink = ref(null);

const modalClose = (item) => {
  errorLink.value = null;
  successLink.value = null;
  if (modal.value) {
    modal.value = null;
    email.value = null;
  } else {
    modal.value = item.RID;
    email.value = item.email;
  }
};

const sendLink = () => {
  errorLink.value = null;
  successLink.value = null;
  loadingSendLink.value = true;
  postApi("/sendLink", {
    sendEmail: email.value,
    UID: modal.value,
  }).then((res) => {
    if (res.error) {
      errorLink.value = res;
    } else {
      successLink.value = "Ссылка отправлена!";
    }
    loadingSendLink.value = false;
  });
};

watch(
  () => props.filesPass,
  (newVal) => {
    if (Array.isArray(newVal)) {
      filesPass.value = [...newVal];
    } else if (newVal && typeof newVal === "object") {
      filesPass.value = [newVal];
    } else {
      filesPass.value = [];
    }
  },
  { immediate: true }
);

watch(
  () => props.passport,
  (value) => {
    if (value === undefined) {
      // Бэкенд без поля passport — берём статус отдельным запросом.
      loadRecognition();
      return;
    }
    unavailable.value = !!value?.unavailable;
    setRecognition(value?.recognition, true);
  },
  { immediate: true }
);

watch(
  () => props.docs,
  (newVal) => {
    if (newVal && typeof newVal === "object") {
      docs.value = newVal;
    } else {
      docs.value = {};
    }
  },
  { immediate: true }
);
</script>